import { app } from '../../bootstrap/core';
import { PlausibleService } from './plausible/plausible.service';

app.service('trackingService', PlausibleService);



// WEBPACK FOOTER //
// ./src/app/common/tracking/tracking.js